/**
 * Buchungskonten für Zahlungen ohne Beleg (Kredit, Gesellschafter, Geldtransit, Gebühren).
 */
import React, { useEffect, useState } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { ChevronDown, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { ACCOUNT_SETTING_FIELDS, loadAccountSettings, saveAccountSettings } from '@/lib/reconcileApi';

export default function AbgleichKontenCard({ actor }) {
  const queryClient = useQueryClient();
  const { data, error } = useQuery({ queryKey: ['fibu-account-settings'], queryFn: loadAccountSettings, retry: false });
  const [values, setValues] = useState({});
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (data) setValues(data); }, [data]);
  if (error) return null;

  const save = async () => {
    setBusy(true);
    try {
      await saveAccountSettings(values, actor);
      queryClient.invalidateQueries({ queryKey: ['fibu-account-settings'] });
      toast.success('Buchungskonten gespeichert.');
    } catch (err) {
      toast.error(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <details className="group rounded-xl border border-slate-200 bg-white">
      <summary className="flex min-h-[44px] cursor-pointer list-none items-center justify-between gap-2 px-4 py-3 text-sm font-semibold text-slate-900">
        Buchungskonten ohne Beleg
        {!data?.gesellschafter && <span className="ml-auto mr-2 rounded-full bg-amber-50 px-2 py-0.5 text-[11px] font-semibold text-amber-800">Gesellschafter fehlt</span>}
        <ChevronDown className="h-4 w-4 text-slate-500 transition-transform group-open:rotate-180" aria-hidden="true" />
      </summary>
      <div className="space-y-3 border-t border-slate-100 px-4 py-3">
        {ACCOUNT_SETTING_FIELDS.map((f) => (
          <label key={f.key} className="block">
            <span className="block text-xs font-semibold text-slate-700">{f.label}</span>
            <Input value={values[f.key] || ''} inputMode="numeric" placeholder={f.hint}
              onChange={(e) => setValues((p) => ({ ...p, [f.key]: e.target.value }))} className="mt-1 h-11 font-mono text-sm" />
          </label>
        ))}
        <Button className="h-11 w-full bg-slate-900 text-white" disabled={busy} onClick={save}>
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Speichern
        </Button>
      </div>
    </details>
  );
}
